export default {
      id: "i-checked-usage",
      viewBox: "0 0 512.000000 512.000000",
      url: __webpack_public_path__ + "img/sprite.svg#i-checked",
      toString: function () {
        return this.url;
      }
    }